// The Trips grid's Launch Policy cell.
//
// CP-6796: blank when launch policies are off for the policy's owner (the row's
// `launch_policy_enforced` is false). Every operator gets a "Draft" default
// policy, and "Default (Draft)" read as if it applied. A row without the field
// (an older backend) keeps the label, so the two repos can deploy in either order.
const launchPolicyLabel = (row) => {
    if (row.launch_policy_enforced === false) return '';
    if (row.launch_policy) return row.launch_policy.name;
    return `Default (${row.default_launch_policy ? row.default_launch_policy.name : 'None'})`;
};

export default launchPolicyLabel;
